<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormRequestType1 }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PRFormRequestType2 }}
            <span class="required">*</span>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="store.formData.Types" value="Police" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck1">{{ store.lexicon[store.culture].PRFormRequestType3 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="store.formData.Types" value="Emergency" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck2">{{ store.lexicon[store.culture].PRFormRequestType4 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck3" v-model="store.formData.Types" value="CCTV" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck3">{{ store.lexicon[store.culture].PRFormRequestType5 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck4" v-model="store.formData.Types" value="Bodycam" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck4">{{ store.lexicon[store.culture].PRFormRequestType6 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck5" v-model="store.formData.Types" value="Medical" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck5">{{ store.lexicon[store.culture].PRFormRequestType7 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck6" v-model="store.formData.Types" value="Access" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck6">{{ store.lexicon[store.culture].PRFormRequestType8 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck7" v-model="store.formData.Types" value="Contract" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck7">{{ store.lexicon[store.culture].PRFormRequestType9 }}</label>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customCheck8" v-model="store.formData.Types" value="Other" @@change="validatePage('TYPE')">
            <label class="custom-control-label" for="customCheck8">{{ store.lexicon[store.culture].PRFormRequestType10 }}</label>
        </div>

        <div v-if="store.errors.Types" class="error">{{ store.lexicon[store.culture].PRFormRequestType11 }}</div>

        <div class="mt-2 d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="goBackToPage('BACKGROUND')">{{ store.lexicon[store.culture].Back }}</button>
            <button type="button" class="btn btn-primary" @click="goToTypePage(0)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

</script>

<style>
    .custom-checkbox {
        display: block;
    }
</style>